import classNames from 'classnames';
import { ComponentProps, FC, ReactNode } from 'react';

import { CAR_PURCHASE_STATUS } from 'src/constants';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { AddToWatchList, AddToWatchListStyle } from 'src/general/components/AddToWatchList/AddToWatchList';
import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import { Button } from 'src/general/components/Button/Button';
import { getMicrocopy } from 'src/stores/microcopyStore';

import styles from './ModalPurchaseInProgress.module.scss';

interface Props extends Omit<ComponentProps<typeof BasicModal>, 'id' | 'children' | 'title'> {
  similarCarsUrl: string;
  carPurchaseStatus: CAR_PURCHASE_STATUS;
  addToWatchlistProps: Prettify<Omit<ComponentProps<typeof AddToWatchList>, 'style' | 'className' | 'labelsOverwrite'>>;
}

type ModalContent = {
  [key: string]: {
    title: ReactNode;
    content: ReactNode;
  };
};

export const ModalPurchaseInProgress: FC<Props> = ({
  addToWatchlistProps,
  similarCarsUrl,
  carPurchaseStatus,
  ...props
}) => {
  const modalContent: ModalContent = {
    reserved: {
      title: getMicrocopy(MICROCOPY.PDP_PURCHASE_INPROGRESS_RESERVED_MODAL_TITLE),
      content: getMicrocopy(MICROCOPY.PDP_PURCHASE_INPROGRESS_RESERVED_MODAL_CONTENT, true),
    },
    draftOrder: {
      title: getMicrocopy(MICROCOPY.PDP_PURCHASE_INPROGRESS_DRAFT_ORDER_MODAL_TITLE),
      content: getMicrocopy(MICROCOPY.PDP_PURCHASE_INPROGRESS_DRAFT_ORDER_MODAL_CONTENT, true),
    },
  };

  const addToWatchlistLabels: ComponentProps<typeof AddToWatchList>['labelsOverwrite'] = {
    save: getMicrocopy(MICROCOPY.PDP_PURCHASE_INPROGRESS_MODAL_ADD_TO_WATCHLIST),
    saved: getMicrocopy(MICROCOPY.PDP_PURCHASE_INPROGRESS_MODAL_ADDED_TO_WATCHLIST_LABEL),
  };

  return (
    <BasicModal
      {...props}
      id="purchase-in-progress"
      title={modalContent[carPurchaseStatus]?.title}
      footer={
        <>
          <AddToWatchList
            {...addToWatchlistProps}
            className={classNames(styles.button, styles.addToWatchlist)}
            style={AddToWatchListStyle.button}
            labelsOverwrite={addToWatchlistLabels}
            disableSnackbar
          />
          <Button
            variant="secondary"
            href={similarCarsUrl}
            data-testid="PurchaseInprogressModal-component-viewSimilarCarBtn"
            size="small"
            className={styles.button}
          >
            {getMicrocopy(MICROCOPY.GENERAL_CTA_NOT_AVAILABLE)}
          </Button>
        </>
      }
    >
      {modalContent[carPurchaseStatus]?.content}
    </BasicModal>
  );
};
